import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { BackdropComponent } from '../backdrop/backdrop.component';
import { Router, RouterModule } from '@angular/router';
import { AppHeaderComponent } from '../app-header/app-header.component';
import { SidebarService } from '../../../services/sidebar.service';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, RouterModule, AppHeaderComponent, AppSidebarComponent, BackdropComponent],
  templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent {
  readonly isExpanded$;
  readonly isMobileOpen$;

  constructor(
    public sidebarService: SidebarService,
    private router: Router,
  ) {
    this.isExpanded$ = this.sidebarService.isExpanded$;
    this.isMobileOpen$ = this.sidebarService.isMobileOpen$;
  }

  isStandaloneCalendarPage() {
    const path = this.router.url.split(/[?#]/)[0];
    return path === '/audit/calendar' || path.startsWith('/audit/calendar/');
  }
}
